<template>
  <div class="coaching-presentation">
    <div class="coaching-presentation__layout">
      <div class="coaching-presentation__header">
        <div class="coaching-presentation__banner">
          <div class="coaching-presentation__url">www.ChessSquad.com</div>
        </div>
      </div>

      <div class="coaching-presentation__main">
        <div class="coaching-presentation__content">
          <!-- a dummy component that flex grow 1 when showClassroll to push content to the right-->
          <div v-if="showClassRoll" style="flex-grow: 1"></div>
          <slot name="board" />
          <div class="coaching-presentation__classroll" v-if="showClassRoll">
            <slot name="classroll" />
          </div>
        </div>
      </div>
    </div>

    <div class="controls-area">
      <slot name="controls"></slot>
    </div>

    <!-- Add KeyboardShortcutsHelp -->
    <!-- <div class="coaching-presentation__keyboard-help">
        <h1>
          {{ topicTitle }}
          <span class="subtitle is-5">{{ scenarioTitle }}</span>
        </h1>

        <slot name="keyboard-help"></slot>
      </div> -->
  </div>
</template>

<script>
export default {
  name: "CoachingPresentationLayout",
  props: {
    topicTitle: {
      type: String,
      default: "",
    },
    scenarioTitle: {
      type: String,
      default: "",
    },
    showClassRoll: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.coaching-presentation {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgb(255, 255, 255);
  z-index: 32;
  box-sizing: border-box;
  overflow: hidden;
}

.coaching-presentation__layout {
  width: 100%;
  height: min(100vh, 69vw);
  padding: 1rem 0;
  display: flex;
  justify-content: center;
  position: relative; /* Added for absolute positioning of children */
}

.coaching-presentation__main {
  width: calc(100%); /* Add space for rotated elements */
  max-width: 1400px;
  height: calc(100vh);
  display: flex;
  flex-direction: column;
}

.coaching-presentation__content {
  height: 100%;
  display: flex;
  gap: 2rem;
  align-items: flex-start;
  justify-content: center;
}

.coaching-presentation__classroll {
  height: var(--board-size, 560px);
  max-width: calc(100vw - 100vh - 50px);
  flex-shrink: 0;
}

.coaching-presentation__header {
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  transform: rotate(-90deg) translateX(-50%);
  transform-origin: left top;
  flex: none;
  white-space: nowrap;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.coaching-presentation__url {
  color: white;
  font-size: min(5vw, 5rem); /* Scale with viewport width, with max size */
  font-weight: bold;
  padding: 0 2vw; /* Responsive padding */
  text-align: center;
  white-space: nowrap;
}

.coaching-presentation__banner {
  width: 100%;
  background-color: #2962ff;
}

/* Simple controls that show on hover */
.controls-area {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  transition: opacity 0.3s;
  opacity: 0;
  z-index: 10;
  margin: 0 auto;
  width: fit-content;
}

/* Show controls on hover */
.controls-area:hover {
  opacity: 1;
}

.coaching-presentation__keyboard-help {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 40;
}
</style>
